import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./Testimonials.module.css";

import img1 from "../../images/לילך מורד המלצות 1.webp";
import img2 from "../../images/לילך מורד המלצות 2.webp";
import img3 from "../../images/לילך מורד המלצות 3.webp";
import img4 from "../../images/לילך מורד המלצות 4.webp";
import img5 from "../../images/לילך מורד המלצות 5.webp";

gsap.registerPlugin(ScrollTrigger);

const images = [img1, img2, img3, img4, img5];

const WHATSAPP_NUMBER = "972505864422";
const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("היי לילך, הגעתי מהאתר שלך ואשמח שנדבר")}`;

const Testimonials = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const el = sectionRef.current;
      if (!el) return;

      gsap.fromTo(
        el.querySelector("[data-test-title]"),
        { opacity: 0, y: 30 },
        {
          opacity: 1, y: 0, duration: 0.9, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 80%", once: true },
        }
      );

      gsap.fromTo(
        el.querySelector("[data-test-scroll]"),
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0, duration: 0.8, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 70%", once: true },
        }
      );

      const cta = el.querySelector("[data-test-cta]");
      if (cta) {
        gsap.fromTo(cta, { opacity: 0, y: 24 }, {
          opacity: 1, y: 0, duration: 0.8, ease: "power3.out",
          scrollTrigger: { trigger: cta, start: "top 90%", once: true },
        });
      }
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.title} data-test-title>
          וזה מה שיש ללקוחות שלי לומר בסוף התהליך
        </h2>

        <div className={styles.scrollWrap} data-test-scroll>
          <div className={styles.scrollArea}>
            {images.map((src, i) => (
              <div key={i} className={styles.imgClip}>
                <img
                  src={src}
                  alt={`המלצה ${i + 1}`}
                  className={styles.screenshot}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          <div className={styles.fadeTop} />
          <div className={styles.fadeBottom} />
        </div>

        <div className={styles.ctaWrap} data-test-cta>
          <a href={waUrl} target="_blank" rel="noopener noreferrer" className={styles.ctaBtn}>
            <span>לשיחת ייעוץ ללא עלות לחצו כאן</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
